import React, { useRef } from "react";
import styles from '../../styles/pstlandingpage.module.scss';
import Row from 'react-bootstrap/Row';
import CustomImage from "../CustomImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { Container } from "react-bootstrap";
import { sliderSpeed } from "../../utils/constants";
import LazyMedia from "../LazyMedia";
import LazyReveal from "../LazyReveal";

const VideoTestimonials: React.FC = (props: any) => {
  const sliderRef = useRef<Slider>(null);
  const limitedTestimonials = props.testimonialVideos?.sort((firstVideoTestimonial: any, secondVideoTestimonial: any) => secondVideoTestimonial.id - firstVideoTestimonial.id)?.slice(0, 15);
  const videosCount = props.testimonialVideos?.length || 0;
  const videosSlidersettings = {
    infinite: videosCount > 3,
    arrows: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 1,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          infinite: videosCount > 2,
          autoplay: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dotsClass: styles.sliderDots,
          infinite: videosCount > 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: sliderSpeed.mobileAutoplaySpeed,
        }
      }
    ]
  };

  return (
       <LazyReveal className={styles.achievements} style={{ backgroundColor: props.sectionBgColor || "#ffffff", ...(props?.parentContainerStyles ?? {}) }}>
        <Container>
        <div className={styles.containerDiv}>
        <Row className={styles.heading}>
          <h2>{props.title}</h2>
          <p className={styles.description}>{props.subTitle}</p>
        </Row>
        <div className={styles.sliderContainer}>
          <Slider {...videosSlidersettings} className={styles.slider} ref={sliderRef}>
            {limitedTestimonials?.length > 0 &&
              limitedTestimonials?.map((content: any, index: any) => {
                return (
                  <div className={styles.achievementsDiv} key={index}>
                    <div className={styles.icon}>
                      <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z" fill="#226CF5" />
                          <path fillRule="evenodd" clipRule="evenodd" d="M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z" fill="#226CF5" />
                        </svg>
                    </div>
                    <div className={styles.videoDiv}>
                      <LazyLoadComponent>
                        <LazyMedia iframeClassName={styles.studVideo} 
                          src={content.videoLink}
                          title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></LazyMedia>
                      </LazyLoadComponent>
                    </div>
                    <div className={styles.content}>
                      <h4>{content.name}</h4>
                      {content?.designation ? (
                        <p>{content.designation}</p>
                      ) : (
                        <p>{content.university}</p>
                      )}
                    </div>
                  </div>
                )
              }
              )}
          </Slider>
          {props.testimonialVideos?.length > 3 &&
            <div className={styles.arrowsClass}>
              <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
              </div>
              <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
              </div>
            </div>}
        </div>
      </div>
        </Container>
    </LazyReveal>
  )
}
export default VideoTestimonials;